import { Stack, Text, TextField, View } from "@towersystems/roam-common-native";
import { SetupNative2faFormValues } from "../../types";
import { Controller, useFormContext } from "react-hook-form";
import { useSetup2fa } from "../../../../../../utilities/2fa/hooks";
import { useTranslation } from "../../../../../../utilities/i18n";
import { OTPInput } from "../../../../../../components/OTPInput";

export interface VerifyMfaCodeFieldsetProps {
  onComplete: () => void;
}

export const VerifyMfaCodeFieldset = ({
  onComplete,
}: VerifyMfaCodeFieldsetProps) => {
  const { t } = useTranslation("settings");
  const { handleOnSubmit } = useSetup2fa();
  const formContext = useFormContext<SetupNative2faFormValues>();
  const { control, formState, handleSubmit } = formContext;
  const { errors, isValid, isDirty, isSubmitting } = formState;
  const isDisabled = !isValid || !isDirty || isSubmitting;

  async function handleFinalSubmit(values: SetupNative2faFormValues) {
    return handleOnSubmit(values)?.then((success) => {
      if (success) {
        onComplete();
      }
    });
  }

  return (
    <Stack vertical>
      <View>
        <Text>{t("form.native_2fa_confirm_password.label")}</Text>
        <Controller
          name="data.password"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <TextField
              value={value ?? ""}
              secureTextEntry
              onChangeText={onChange}
              validationMessage={error ? error.message : undefined}
              placeholder={t("form.native_2fa_confirm_password.placeholder")}
            />
          )}
        />
      </View>

      <Stack vertical>
        <View>
          <Text fontWeight="bold" variant="heading3">
            {t("form.native_2fa_verify_code.label")}
          </Text>
          <Text>{t("form.native_2fa_verify_code.description")}</Text>
        </View>

        <View style={{ maxWidth: 300, width: "100%" }}>
          <Controller
            control={control}
            name="data.code"
            render={({ field: { onChange, value } }) => {
              let normalizedValue = value ? value : "";
              return (
                <OTPInput
                  value={normalizedValue.split("")}
                  onChange={(v) => {
                    onChange(v.join(""));
                  }}
                  length={6}
                />
              );
            }}
          />
        </View>
      </Stack>
      {errors.root?.serverError &&
        errors.root.serverError.message !== `MFA_REQUIRED_ERROR` && (
          <Text color="destructive">{errors.root.serverError.message}</Text>
        )}
    </Stack>
  );
};
